import { render } from "./ShowingsBanner.vue?vue&type=template&id=fde4567c&scoped=true"
import script from "./ShowingsBanner.vue?vue&type=script&lang=js"
export * from "./ShowingsBanner.vue?vue&type=script&lang=js"

import "./ShowingsBanner.vue?vue&type=style&index=0&id=fde4567c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fde4567c"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
